export default "__VITE_ASSET__zYLtFsOJ__"